import { render, staticRenderFns } from "./WorkshopFinishDialog.vue?vue&type=template&id=4333e0a8&scoped=true"
import script from "./WorkshopFinishDialog.vue?vue&type=script&lang=js"
export * from "./WorkshopFinishDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkshopFinishDialog.vue?vue&type=style&index=0&id=4333e0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333e0a8",
  null
  
)

export default component.exports